module.exports = __webpack_public_path__ + "img/gsjmf.532311c.png";